import {Artikel} from '../../../models/artikel';
import {ArtikelVerfuegbarkeit} from '../../../models/artikel-verfuegbarkeit';

export class Verfuegbarkeitsanfrage {
  artikel: Artikel;
  status: ArtikelVerfuegbarkeit;
}
